const FeatureFlagMixin = {
  methods: {
    isFeatureEnabled(name) {
      const isEnabled = this.$store.getters['auth/hasFeatureFlagEnabled']({ name });
      return !!isEnabled;
    },
  },
};

export default FeatureFlagMixin;